import { css } from '@emotion/core';
import { Button } from '@material-ui/core';
import { AttachFile } from '@material-ui/icons';
import React from 'react';

import { FilePayload } from 'shared/types/file-payload';

import { readFile } from '../lib/read-file-payload';
import { Attachment } from './attachment';
import { AttachmentButton } from './attachment-button';

interface StageAttachmentsListProps {
    attachments: FilePayload[];
    onChange: (attachments: FilePayload[]) => void;
}

const listStyles = css`
    display: flex;
    flex-wrap: wrap;
`;

const buttonStyles = css`
    display: inline-flex;
    margin: -5px 0 -10px;

    .MuiButton-root {
        background: #f1f1f1;
        padding: 4px 10px;
        box-shadow: none;
    }
`;

export const StageAttachmentsList: React.FC<StageAttachmentsListProps> = ({ attachments, onChange }) => {
    const handleRemoveAttachment = (index: number) => () => {
        const newAttachments = [...attachments.slice(0, index), ...attachments.slice(index + 1)];
        onChange(newAttachments);
    };

    const handleFileNameUpdate = (index: number) => (filename: string) => {
        const newAttachments = attachments.map((a, i) => {
            if (i === index) {
                return {
                    ...a,
                    filename
                };
            } else {
                return a;
            }
        });
        onChange(newAttachments);
    };

    const attachmentsList = attachments.map((attachment, index) => (
        <Attachment
            key={index}
            file={attachment}
            onRemove={handleRemoveAttachment(index)}
            onFileNameUpdate={handleFileNameUpdate(index)}
        />
    ));

    return <div css={listStyles}>{attachmentsList}</div>;
};

interface StageAttachmentButtonProps {
    personId: string;
    jobId: string;
    attachments: FilePayload[];
    onChange: (attachments: FilePayload[]) => void;
}

export const StageAttachmentButton: React.FC<StageAttachmentButtonProps> = ({
    personId,
    jobId,
    attachments,
    onChange
}) => {
    const handleAddAttachments = (files: File[]) => {
        Promise.all(files.map(readFile)).then((newAttachments) => {
            onChange([...attachments, ...newAttachments]);
        });
    };

    const handleAddUploadedFiles = (uploadedFiles: FilePayload[]) => {
        onChange([...attachments, ...uploadedFiles]);
    };

    const renderButton = (props: { onClick: (event: React.MouseEvent<HTMLElement>) => void }) => {
        return (
            <span css={buttonStyles}>
                <Button variant="contained" onClick={props.onClick} startIcon={<AttachFile />}>
                    Attach files
                </Button>
            </span>
        );
    };

    return (
        <AttachmentButton
            personId={personId}
            jobId={jobId}
            onDrop={handleAddAttachments}
            onUploadedFilesSelect={handleAddUploadedFiles}
            renderButton={renderButton}
        />
    );
};
